
import { defineComponent } from 'vue';
import CreditTemplate from '@/components/templates/CreditTemplate.vue';
import { useI18n } from '@/plugins/i18n';
import JaMessages from '@/assets/i18n/ja/credit.json';
import EnMessages from '@/assets/i18n/en/credit.json';
import { pageview } from 'vue-gtag';

export default defineComponent({
  name: 'Credit',
  components: { CreditTemplate },
  methods: {
    track() {
      pageview({ page_path: '/credit' });
    },
  },
  setup() {
    const i18n = useI18n();
    i18n.$setMessages(JaMessages, EnMessages);

    return {
      i18n,
    };
  },
});
